import { render } from "./MaoOverlay.vue?vue&type=template&id=4c89e590&scoped=true"
import script from "./MaoOverlay.vue?vue&type=script&lang=js"
export * from "./MaoOverlay.vue?vue&type=script&lang=js"

import "./MaoOverlay.vue?vue&type=style&index=0&id=4c89e590&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c89e590"]])

export default __exports__